import gql from "graphql-tag";

export default gql`
query PaginationLimit {
    paginationLimit @client
}
`